import TriggerSerializer from 'eflex/serializers/trigger';

export default class AudioTriggerSerializer extends TriggerSerializer {}
